import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk } from '../index';
import { fetchStockStatistics } from '../../api/stockApi';

interface StockState {
  symbol: string | null;
  data: any | null;
  loading: boolean;
  error: string | null;
}

const initialState: StockState = {
  symbol: null,
  data: null,
  loading: false,
  error: null,
};

const stockSlice = createSlice({
  name: 'stock',
  initialState,
  reducers: {
    fetchStockStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchStockSuccess(state, action: PayloadAction<{ symbol: string; data: any }>) {
      state.symbol = action.payload.symbol;
      state.data = action.payload.data;
      state.loading = false;
    },
    fetchStockFailure(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { fetchStockStart, fetchStockSuccess, fetchStockFailure } = stockSlice.actions;

export const fetchStockDataThunk =
  (symbol: string): AppThunk =>
  async (dispatch) => {
    dispatch(fetchStockStart());
    try {
      const data = await fetchStockStatistics(symbol);
      dispatch(fetchStockSuccess({ symbol, data }));
    } catch (err: any) {
      dispatch(fetchStockFailure(err.message));
    }
  };

export default stockSlice.reducer;
